import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './qschecks-controlling-filter.reducer';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {FunktionsbereichRollen} from '../../../../clients/qschecks';

export function getModuleState() {
    return createFeatureSelector<ModuleState>('QschecksControllingFilterPage');
}

export function getPageState() {
    return createSelector(getModuleState(), (state: ModuleState) => state.page);
}


export function getFunktionsbereichePruefplaene() {
    return createSelector(getPageState(), (state: PageState) => {
        if (state.fbPruefplaeneListe === undefined || state.fbPruefplaeneListe === null) {
            return [];
        }
        const liste: Array<ListInputItem> = [];

        state.fbPruefplaeneListe.forEach((fbPruefplaene) => fbPruefplaene.pruefplan_liste.map((pruefplan ) => {
            liste.push(<ListInputItem>{
                groupId: fbPruefplaene.funktionsbereich.funktionsbereich_id,
                groupTitle: fbPruefplaene.funktionsbereich.titel,
                itemId: pruefplan.pruefplan_id,
                itemTitle: pruefplan.titel,
                item: pruefplan
            });
        }));

        return liste;
    });
}

export function getFunktionsbereichePruefplaeneLaden() {
    return createSelector(getPageState(), (state: PageState) => state.fbPruefplaeneListeLaden);
}

export function getFunktionsbereichePruefplaeneFehler() {
    return createSelector(getPageState(), (state: PageState) => state.fbPruefplaeneListeFehler);
}

export function getPruefplanSelected() {
    return createSelector(getPageState(), (state: PageState) => state.pruefplanSelected);
}

export function getPrueferrollenListe() {
    return createSelector(getPageState(), (state: PageState) => {
        if (state.filterOptions === undefined || state.filterOptions === null) {
            return [];
        }
        const liste: Array<ListInputItem> = [];

        state.filterOptions.pruefer_rolle_liste.forEach((fbRollen: FunktionsbereichRollen) => fbRollen.rollen.map((rolle ) => {
            liste.push(<ListInputItem>{
                groupId: fbRollen.funktionsbereich.funktionsbereich_id,
                groupTitle: fbRollen.funktionsbereich.titel,
                itemId: rolle.rolle_id,
                itemTitle: rolle.titel,
                item: rolle
            });
        }));

        return liste;
    });
}

export function getSaisonUndQuartalListe() {
    return createSelector(getPageState(), (state: PageState) => {
        if (state.filterOptions === undefined || state.filterOptions === null) {
            return [];
        }
        const liste: Array<ListInputItem> = [];

        // Saisons hinzufügen
        if (state.filterOptions.saison_liste2) {
            // Sortiere Saisons absteigend (neueste zuerst)
            const sortedSaisons = [...state.filterOptions.saison_liste2].sort((a, b) => {
                return b.titel.localeCompare(a.titel);
            });

            sortedSaisons.forEach((saison) => {
                liste.push(<ListInputItem>{
                    groupId: '1-saisons',
                    groupTitle: 'Saisons',
                    itemId: saison.titel,
                    itemTitle: saison.titel,
                    item: {type: 'saison', data: saison}
                });
            });
        }

        // Quartale hinzufügen
        if (state.filterOptions.quartal_liste) {
            // Sortiere Quartale absteigend (aktuellstes zuerst)
            const sortedQuartale = [...state.filterOptions.quartal_liste].sort((a, b) => {
                // Erst nach Jahr absteigend sortieren
                if (b.jahr !== a.jahr) {
                    return b.jahr - a.jahr;
                }
                // Dann nach Quartal absteigend sortieren
                return b.q - a.q;
            });

            sortedQuartale.forEach((quartal) => {
                const titel = `Q${quartal.q}/${quartal.jahr}`;
                liste.push(<ListInputItem>{
                    groupId: '2-quartale',
                    groupTitle: 'Quartale',
                    itemId: titel,
                    itemTitle: titel,
                    item: {type: 'quartal', data: quartal}
                });
            });
        }

        return liste;
    });
}

export function getSaisonListe() {
    return createSelector(getPageState(), (state: PageState) => {
        if (state.filterOptions === undefined || state.filterOptions === null) {
            return [];
        }
        const liste: Array<ListInputItem> = [];

        state.filterOptions.saison_liste2.forEach((saison) => {
            liste.push(<ListInputItem>{
                groupId: '',
                groupTitle: '',
                itemId:  saison.titel,
                itemTitle: saison.titel,
                item: saison
            });
        });

        return liste;
    });
}

export function getFilterOptionsLaden() {
    return createSelector(getPageState(), (state: PageState) => state.filterOptionsLaden);
}

export function getFilterOptionsFehler() {
    return createSelector(getPageState(), (state: PageState) => state.filterOptionsFehler);
}
